/**
 * InfilesPanelIllustration.tsx — illustrasjon på blå gradient-flate (4:3)
 *
 * Brukes ved siden av funksjonsakkordionen (variant «files»: original- og
 * modifisert fil) og de nummererte stegene (variant «chip»: ECU-brikke mellom
 * to dokumentstabler). Faste farger (egen blå bakgrunn, ikke tema).
 */

import { useId } from 'react';
import { Box } from '@/components/product/iso';
import styles from '@/components/product/illustrations.module.css';
import { Chip, DocStack } from './parts';

const S = 34;
const OX = 307;
const OY = 150;
const project = (x: number, y: number, z = 0) =>
  `${(OX + (x - y) * 0.866 * S).toFixed(1)},${(OY + (x + y) * 0.5 * S - z * S).toFixed(1)}`;

const TILE: [string, string, string] = ['#ffffff', '#d0e2ff', '#a6c8ff'];

interface InfilesPanelIllustrationProps {
  label: string;
  variant: 'files' | 'chip';
}

export default function InfilesPanelIllustration({ label, variant }: InfilesPanelIllustrationProps) {
  const uid = useId();
  const bg = `${uid}-bg`;

  return (
    <svg className={styles.cubesFrame} viewBox="0 0 672 504" role="img" aria-label={label}>
      <defs>
        <linearGradient id={bg} x1="0" y1="0" x2="0" y2="1">
          <stop offset="0" stopColor="#d0e2ff" />
          <stop offset="1" stopColor="#4589ff" />
        </linearGradient>
      </defs>
      <rect width="672" height="504" fill={`url(#${bg})`} />
      <g transform="translate(0 60)">
        <Box x={0} y={0} z={0} w={variant === 'chip' ? 7.8 : 7} d={5} h={0.3} colors={TILE} project={project} />
        {variant === 'files' ? (
          <>
            <DocStack x={0.6} y={1} z={0.3} sheets={5} project={project} />
            <DocStack x={4.2} y={1} z={0.3} sheets={5} modified project={project} />
          </>
        ) : (
          <>
            <DocStack x={0.3} y={1} z={0.3} sheets={3} w={1.7} project={project} />
            <Chip x={2.7} y={1.3} z={0.3} project={project} />
            <DocStack x={5.8} y={1} z={0.3} sheets={3} w={1.7} modified project={project} />
          </>
        )}
      </g>
    </svg>
  );
}
